import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  ctaContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
  },
  button: {
    border: "1px solid #E0E0E0",
  },
  buttonsContainer: {
    height: 40,
    width: '100%',
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    gap: 5,

  },
  loadedText: {
    width: 200,
    fontSize: 12,
    flexGrow: 1,
    color: theme.palette.grey[500],
    margin: 0,
  },
}));